import React from "react";

export default function ColumbusFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-5col2{fill:#002664}.cls-5col3{fill:#aa0f0f}"}</style>
        </defs>
        <path
          d="M1404.86 1935.26H595.14c-74.69 0-135.46-60.77-135.46-135.46V990.08c0-74.69 60.77-135.46 135.46-135.46h809.72c74.69 0 135.46 60.77 135.46 135.46v809.72c0 74.7-60.77 135.46-135.46 135.46ZM595.14 875.33c-63.27 0-114.75 51.48-114.75 114.75v809.72c0 63.27 51.48 114.75 114.75 114.75h809.72c63.27 0 114.75-51.48 114.75-114.75V990.08c0-63.27-51.48-114.75-114.75-114.75H595.14Z"
          className="cls-5col3"
        />
        <path
          d="m1154.4 752.2-285.41 50.39C778.45 818.57 687.31 777.73 639 699.5c-.12-.19-.51-.85-1.13-1.83-6.53-10.38-30.59-48.68-60.98-49.54-12.11-.34-14.64 5.57-24.81 2.71-8.85-2.48-13.93-8.92-24.05-24.02-37.99-56.73-34.45-67.74-31.42-72.68.08-.13.33-.65.94-1.38 3.08-3.67 13.03-8.34 74.95-21.12 14.68-3.03 74.87-15.06 102.15-1.83 9.05 4.39 16.11 10.69 16.11 10.69 9.38 8.36 13.45 17.37 15.46 19.95 17.88 23.09 44.01 38.39 72.92 42.53 20.21 2.89 41.17 5.09 62.85 6.43 221.47 13.67 401.3-69.79 506.32-132.52h.32c10.34-.1 14.9 12.98 6.75 19.34l-75.81 59.04a41.732 41.732 0 0 0-15.46 40.19c12.99 73.58-36.13 143.76-109.71 156.75Z"
          className="cls-5col2"
        />
        <rect
          width={13.94}
          height={635.13}
          x={882.73}
          y={60.01}
          className="cls-5col2"
          rx={6.97}
          ry={6.97}
          transform="rotate(-10.01 889.891 377.669)"
        />
        <rect
          width={13.94}
          height={532.93}
          x={620.37}
          y={209.32}
          className="cls-5col2"
          rx={6.88}
          ry={6.88}
          transform="rotate(-10.01 627.462 475.904)"
        />
        <rect
          width={13.94}
          height={447.48}
          x={1192.82}
          y={213.58}
          className="cls-5col2"
          rx={6.3}
          ry={6.3}
          transform="rotate(-10.01 1200.044 437.393)"
        />
        <path
          d="M852.43 126.38c50.16 80.18 109.56 164.63 179.97 250.27 25.02 30.43 50.07 59.36 74.98 86.84-11.91-4.43-60.66-21.02-115.05 1.1-39.76 16.18-61.71 44.57-70.14 56.86.76-40.57-.76-85.3-6.04-133.38-11.49-104.54-37.28-192.87-63.71-261.7ZM597.67 267.64c25.05 46.77 58.93 99.7 104.87 153.09a844.709 844.709 0 0 0 54.39 57.5c-7.44-2.77-37.89-13.13-71.87.69-24.84 10.1-38.55 27.84-43.82 35.52.48-25.34-.47-53.29-3.77-83.32-7.18-65.31-23.29-120.49-39.8-163.48ZM1178.68 277.66a1090.28 1090.28 0 0 0 102.41 131.57c22.75 25 45.34 47.49 67.21 67.66-3.15-2.24-43.33-29.85-87.08-12.26-25.47 10.24-38.46 30.3-42.84 37.89a650.81 650.81 0 0 0-5.24-83.3c-7.11-55.76-20.54-103.43-34.46-141.56Z"
          className="cls-5col2"
        />
        <path
          d="m738.96 467.962 2-2.562 183.726 143.491-2 2.561zM1075.994 441.772l1.996-2.565 134.773 104.842-1.996 2.565z"
          className="cls-5col2"
        />
        <path
          d="M586.21 282.89c-2.71.69-7.15 1.61-12.71 1.71-19.38.37-28.03-9.26-45.39-9.99-5.14-.22-13.1.27-23.12 4.42.92-2.64 5.12-13.73 17.15-20.21 10.52-5.67 20.55-4.32 23.62-3.78A86.034 86.034 0 0 0 521.65 236a85.837 85.837 0 0 0-22.47-8.16c8.44-1.38 15.31-.93 19.84-.33 18.78 2.51 27.48 11.63 43.58 10.54 6.68-.45 11.87-2.47 14.99-3.94l8.61 48.78ZM839.68 134.35c-2.71.69-7.15 1.61-12.71 1.71-19.38.37-28.03-9.26-45.39-9.99-5.14-.22-13.1.27-23.12 4.42.92-2.64 5.12-13.73 17.15-20.21 10.52-5.67 20.55-4.32 23.62-3.78a86.034 86.034 0 0 0-24.11-19.04 85.837 85.837 0 0 0-22.47-8.16c8.44-1.38 15.31-.93 19.84-.33 18.78 2.51 27.48 11.63 43.58 10.54 6.68-.45 11.87-2.47 14.99-3.94l8.61 48.78ZM1165.61 283.79c-2.71.69-7.15 1.61-12.71 1.71-19.38.37-28.03-9.26-45.39-9.99-5.14-.22-13.1.27-23.12 4.42.92-2.64 5.12-13.73 17.15-20.21 10.52-5.67 20.55-4.32 23.62-3.78a86.034 86.034 0 0 0-24.11-19.04 85.837 85.837 0 0 0-22.47-8.16c8.44-1.38 15.31-.93 19.84-.33 18.78 2.51 27.48 11.63 43.58 10.54 6.68-.45 11.87-2.47 14.99-3.94l8.61 48.78ZM1515.98 943.37c-25.2-10.85-70.64-28.61-128.75-40.18-295.04-58.78-457.96 132.96-765.88 82.94-33.23-5.4-86.48-16.59-151.32-42.76V724.55c24.4 7.73 74.27 22.23 138.04 30.3 305.24 38.66 460.2-129.22 753.93-76.56 31.45 5.64 86.29 17.71 153.97 46.25v218.82Z"
          className="cls-5col3"
        />
        <path
          d="M1515.98 803.16v73.21c-67.68-28.55-122.52-40.62-153.97-46.26-293.73-52.66-448.69 115.22-753.93 76.56-63.78-8.08-113.64-22.58-138.04-30.3v-73.21c24.4 7.73 74.26 22.22 138.04 30.3 305.25 38.66 460.2-129.22 753.93-76.56 31.45 5.64 86.29 17.71 153.97 46.26Z"
          style={{
            fill: "#fff",
          }}
        />
        {children}
      </g>
    </svg>
  );
}
